var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2054_17329)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.0138,
    height: 14.9694,
    transform: "translate(0 0.515259)",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9172 0.515259H2.09655C0.938658 0.515259 0 1.40886 0 2.51118V13.4887C0 14.591 0.938658 15.4846 2.09655 15.4846H19.9172C21.0751 15.4846 22.0138 14.591 22.0138 13.4887V2.51118C22.0138 1.40886 21.0751 0.515259 19.9172 0.515259Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76331 7.73052L4.22234 8.50194L4.51586 6.86828L3.27051 5.71065L4.99282 5.47413L5.76331 3.98718L6.53274 5.47413L8.25506 5.71065L7.00761 6.86828L7.30322 8.50094L5.76331 7.73052ZM9.43437 3.50916H10.4826V4.50711H9.43437V3.50916ZM10.4826 5.50507H11.5309V6.50303H10.4826V5.50507ZM10.4826 7.50099H11.5309V8.49895H10.4826V7.50099ZM9.43437 9.4969H10.4826V10.4949H9.43437V9.4969Z",
    fill: "#FFDA2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2054_17329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.0138,
    height: 14.9694,
    fill: "white",
    transform: "translate(0 0.515259)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.74ed0bcf153251647efddc090eaa7bfb.svg";
export { ForwardRef as ReactComponent };